// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "-cf-" + {"196": "1f1fd49a172836b1","238": "03309bdf402c23fc",}[chunkId] + ".js"
}